import React from 'react'
import styles from './styles'
import DataTable from '../../DataTable'
import { TrialCache } from '../../TrialCache'
import getTrialUiHeaders from '../../TrialUI/Hooks/getHeaders'
import { useHistory, useLocation } from 'react-router-dom'
import { InstanceContext } from '../../../InstanceContext'
import { UserContext } from '../../../Context/UserContext'
import axios from 'axios'
import axiosConfig from '../../../config/axios.config'
import { trackActivity, trackError } from '../../../utils/activityTracker'

const TrialsLandingPage = props => {
  const { cache, refreshCache, prioritizeCache } = React.useContext(TrialCache)
  const { user, userAction } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  const history = useHistory()
  const location = useLocation()
  const [refreshingUI, setRefreshingUI] = React.useState(false)
  const [customMemo, setCustomMemo] = React.useState(0)
  const headers = getTrialUiHeaders(['nct', 'briefTitle']) // removing 'priorityTrial'
  const trialInstance = contextInstance || user.instance

  const trialsData = cache.allTrials.data;

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  // function 'handleCellSwitchAction' is not in use, as it is for 'priorityTrial' switch, which is commented/removed now
  const handleCellSwitchAction = (value, valueKey, dataObject) => {
    let url = `${axiosConfig.apiUrl}/rt/savePriorityTrial/${trialInstance}/newTrial/${user.email}`
    if (!value) url = `${axiosConfig.apiUrl}/rt/savePriorityTrial/${trialInstance}/removeTrial/${user.email}`
    let data = { trial: dataObject._id }
    if (props.params && props.params.isPi) data.user = user
    setRefreshingUI(true)
    axios.post(url, data) // removed 'axiosConfig.auth' as token is updated on login
      .then(res => {
        const foundIndex = trialsData.findIndex(trial => trial._id === dataObject._id)
        trialsData[foundIndex].priorityTrial = value
        // refreshCache('allTrials');
        setRefreshingUI(false)
        setCustomMemo(customMemo + 1)
      })
      .catch(err => {
        console.log(err)
        trackError({ error: err, history: props.history })
        if(err && err.response && err.response.status === 403) {
          userAction({type: 'logout'})
        }
        setRefreshingUI(false)
      })
  }

  return (
    <div style={styles.container}>
      <DataTable
        headerSettings={headers}
        data={trialsData}
        memo={customMemo}
        cellActions={{ priorityTrialSwitch: handleCellSwitchAction }}
        options={{
          customTopOffset: '45px',
          cellSettingsButton: { onClick: () => {
            console.log('settings button clicked');handleActivityLogUpdate(`TrialsLandingPage.handleActivityLogUpdate`) } }
        }}
        cellRoute={'/' + trialInstance + '/trials/overview/dtdata:_id'}
        routeState={{ title: 'Overview' }}
        history={history}
        location={location}
        refreshing={refreshingUI}
      />
    </div>
  )
}

export default TrialsLandingPage
